import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "file-name-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "view-icon el-icon-zoom-in" }, null, -1)
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "preview-item-common",
    style: _normalizeStyle({ width: _ctx.width, 'margin-top': _ctx.currentItemTopSpace })
  }, [
    _createElementVNode("label", {
      style: _normalizeStyle({ width: _ctx.currentLabelWidth, 'text-align': _ctx.currentLabelAlign })
    }, [
      (_ctx.$slots.label)
        ? _renderSlot(_ctx.$slots, "label", { key: 0 })
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ], 64))
    ], 4),
    _createElementVNode("div", null, [
      (_ctx.$slots.default)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_ctx.content || _ctx.content === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.type === 'textarea')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.$utils.textareaFormat(_ctx.content)
                  }, null, 8, _hoisted_1))
                : (_ctx.type === 'file')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.content.split(','), (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "preview-item--file",
                        onClick: ($event: any) => (_ctx.openFile(file))
                      }, [
                        (_ctx.$utils.isImage(file))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: file,
                              alt: ""
                            }, null, 8, _hoisted_3))
                          : (_openBlock(), _createElementBlock("i", {
                              key: 1,
                              class: _normalizeClass(["fa", _ctx.getFileIcon(file.split('.').pop())])
                            }, null, 2)),
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createElementVNode("div", {
                            class: "file-name",
                            title: _ctx.getFileName(file)
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(file)), 1)
                          ], 8, _hoisted_6)
                        ])
                      ], 8, _hoisted_2))
                    }), 128))
                  : (_ctx.type === 'date')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.$utils.dateTypeFormat(_ctx.content, { dateType: _ctx.dateType })), 1)
                      ], 64))
                    : (_ctx.type === 'time')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.$utils.minToTime(_ctx.content)), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createTextVNode(_toDisplayString(_ctx.content), 1)
                        ], 64))
            ], 64))
          : _createCommentVNode("", true)
    ])
  ], 4))
}